<template>
  <v-layout row wrap justify-center blue-background class="pt-3 pb-2">
    <v-flex xs12 sm4>
      <v-card class="transparent" flat>
        <v-card-title primary-title class="layout">
          <div class="headline justify-center">About Us</div>
        </v-card-title>
        <v-card-text class="transparent">
          Development for Resilient Residence is supported by Suncorp Insurance and Queensland Government (Advance Queensland)
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm4 offset-sm1>
      <v-card class="transparent" flat>
        <v-card-title primary-title class="layout">
          <div class="headline">Contact us</div>
        </v-card-title>
        <v-card-text class="pb-0"><div class="">Get in touch</div></v-card-text>
        <v-list class="transparent pt-0">
          <!--
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon class="blue--text text--lighten-2">phone</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>123-456-7891</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon class="blue--text text--lighten-2">place</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>QLD, Australia</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
          -->
          <v-list-tile>
            <v-list-tile-action>
              <v-icon class="blue--text text--lighten-2">email</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>daniel.smith8@jcu.edu.au</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "About"
};
</script>
